var render = function render(){
  var _vm$results, _vm$results$totalAmou, _vm$results$totalAmou2, _vm$results2, _vm$results2$returned, _vm$results2$returned2, _vm$results3, _vm$results3$commissi, _vm$results3$commissi2, _ref, _vm$results4, _vm$results4$totalAmo, _vm$results5, _vm$results5$returned, _vm$results6, _vm$results6$commissi;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-content', {
    attrs: {
      "max-width": "2056"
    }
  }, [_c('v-row', {
    staticClass: "mt-4 px-1",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "tit tit--lg text-start",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("주문 관리")]), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "color": "secondary",
      "rounded": ""
    },
    on: {
      "click": function ($event) {
        _vm.showSearch = !_vm.showSearch;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-filter-variant")]), _vm._v("검색필터 ")], 1)], 1)], 1), _c('v-expand-transition', [_c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSearch,
      expression: "showSearch"
    }],
    staticClass: "elevation-1 mt-2 mx-1"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold"
  }, [_vm._v("검색필터")]), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-date-field', {
    attrs: {
      "label": "주문일자",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.filter.createdAt[0],
      callback: function ($$v) {
        _vm.$set(_vm.filter.createdAt, 0, $$v);
      },
      expression: "filter.createdAt[0]"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-date-field', {
    attrs: {
      "label": "주문일자",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.filter.createdAt[1],
      callback: function ($$v) {
        _vm.$set(_vm.filter.createdAt, 1, $$v);
      },
      expression: "filter.createdAt[1]"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.searchKeys,
      "item-text": "text",
      "item-value": "value",
      "label": "검색조건",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        _vm.filter.searchValue = null;
      }
    },
    model: {
      value: _vm.filter.searchKey,
      callback: function ($$v) {
        _vm.$set(_vm.filter, "searchKey", $$v);
      },
      expression: "filter.searchKey"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "검색어",
      "persistent-placeholder": "",
      "hide-details": "",
      "clearable": "",
      "disabled": !_vm.filter.searchKey
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        _vm.page = 1;
        _vm.search(true);
      }
    },
    model: {
      value: _vm.filter.searchValue,
      callback: function ($$v) {
        _vm.$set(_vm.filter, "searchValue", $$v);
      },
      expression: "filter.searchValue"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.statusKeys,
      "item-text": "text",
      "item-value": "value",
      "label": "주문상태",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.filter.status,
      callback: function ($$v) {
        _vm.$set(_vm.filter, "status", $$v);
      },
      expression: "filter.status"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.cashbillState,
      "item-text": "text",
      "item-value": "value",
      "label": "현금영수증 여부",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.filter.cashbillStatus,
      callback: function ($$v) {
        _vm.$set(_vm.filter, "cashbillStatus", $$v);
      },
      expression: "filter.cashbillStatus"
    }
  })], 1)], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.page = 1;
        _vm.search(true);
      }
    }
  }, [_c('v-icon', {
    staticClass: "mt-1 mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-magnify")]), _vm._v("검색 ")], 1)], 1)], 1)], 1), _c('v-layout', {
    staticClass: "mt-4 px-1",
    attrs: {
      "align-end": ""
    }
  }, [_c('v-flex', {
    staticClass: "tit tit--xs",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("검색수 : " + _vm._s(_vm.summary.totalCount.format()))]), _vm.results ? _c('v-flex', {
    staticClass: "tit tit--xs",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("①총 매출액 : " + _vm._s(`${((_vm$results = _vm.results) === null || _vm$results === void 0 ? void 0 : (_vm$results$totalAmou = _vm$results.totalAmount[0]) === null || _vm$results$totalAmou === void 0 ? void 0 : (_vm$results$totalAmou2 = _vm$results$totalAmou.totalAmount) === null || _vm$results$totalAmou2 === void 0 ? void 0 : _vm$results$totalAmou2.format()) || 0} 원`))]) : _vm._e(), _vm.results ? _c('v-flex', {
    staticClass: "tit tit--xs",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("②취소금액 : " + _vm._s(`${((_vm$results2 = _vm.results) === null || _vm$results2 === void 0 ? void 0 : (_vm$results2$returned = _vm$results2.returnedAmount[0]) === null || _vm$results2$returned === void 0 ? void 0 : (_vm$results2$returned2 = _vm$results2$returned.totalAmount) === null || _vm$results2$returned2 === void 0 ? void 0 : _vm$results2$returned2.format()) || 0} 원`))]) : _vm._e(), _vm.results ? _c('v-flex', {
    staticClass: "tit tit--xs",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("③수수료 : " + _vm._s(`${((_vm$results3 = _vm.results) === null || _vm$results3 === void 0 ? void 0 : (_vm$results3$commissi = _vm$results3.commissionTotalAmount[0]) === null || _vm$results3$commissi === void 0 ? void 0 : (_vm$results3$commissi2 = _vm$results3$commissi.totalAmount) === null || _vm$results3$commissi2 === void 0 ? void 0 : _vm$results3$commissi2.format()) || 0} 원`))]) : _vm._e(), _vm.results ? _c('v-flex', {
    staticClass: "tit tit--xs",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("④정산금액(①-②-③) : " + _vm._s(`${(_ref = (((_vm$results4 = _vm.results) === null || _vm$results4 === void 0 ? void 0 : (_vm$results4$totalAmo = _vm$results4.totalAmount[0]) === null || _vm$results4$totalAmo === void 0 ? void 0 : _vm$results4$totalAmo.totalAmount) || 0) - (((_vm$results5 = _vm.results) === null || _vm$results5 === void 0 ? void 0 : (_vm$results5$returned = _vm$results5.returnedAmount[0]) === null || _vm$results5$returned === void 0 ? void 0 : _vm$results5$returned.totalAmount) || 0) - (((_vm$results6 = _vm.results) === null || _vm$results6 === void 0 ? void 0 : (_vm$results6$commissi = _vm$results6.commissionTotalAmount[0]) === null || _vm$results6$commissi === void 0 ? void 0 : _vm$results6$commissi.totalAmount) || 0) || 0) === null || _ref === void 0 ? void 0 : _ref.format()} 원`))]) : _vm._e(), _c('v-spacer'), _c('v-flex', {
    staticClass: "flex-grow-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "green--text",
    attrs: {
      "color": "white",
      "elevation": "1"
    },
    on: {
      "click": _vm.excel
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "20"
    }
  }, [_vm._v("mdi-microsoft-excel")]), _vm._v("엑셀다운로드 ")], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-2 mx-1 elevation-1",
    attrs: {
      "items": _vm.purchases,
      "headers": _vm.purchasesHeaders,
      "hide-default-footer": "",
      "disable-pagination": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.order.orderNo",
      fn: function (_ref2) {
        var item = _ref2.item;
        return _c('div', {}, [_c('div', [_vm._v("주문번호")]), _c('div', [_vm._v(_vm._s(item.order.orderNo))]), _c('div', [_vm._v("구매번호")]), _c('div', [_vm._v(_vm._s(item.purchaseNo))])]);
      }
    }, {
      key: "item.quantity",
      fn: function (_ref3) {
        var item = _ref3.item;
        return _c('span', {}, [_vm._v(_vm._s(item.quantity.format()) + "개")]);
      }
    }, {
      key: `item.product`,
      fn: function (_ref4) {
        var _item$product, _item$product2, _item$product3, _item$product4, _item$product5, _item$product6, _item$product7, _item$product8, _item$product9;
        var item = _ref4.item;
        return [_c('v-layout', {
          attrs: {
            "align-center": ""
          }
        }, [_c('v-img', {
          attrs: {
            "src": `https://daehanbooks.co.kr` + (item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.thumb),
            "max-width": "96",
            "max-height": "96",
            "contain": ""
          }
        }), _c('div', {
          staticClass: "pl-4"
        }, [_c('div', [_c('b', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : _item$product2.name))])]), _c('div', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : _item$product3.salePrice.format()) + "원")]), (item === null || item === void 0 ? void 0 : (_item$product4 = item.product) === null || _item$product4 === void 0 ? void 0 : _item$product4.type) == 'option' ? _c('div', [_vm._v("[" + _vm._s(item === null || item === void 0 ? void 0 : (_item$product5 = item.product) === null || _item$product5 === void 0 ? void 0 : _item$product5.optionalNames.toString()) + "] : " + _vm._s(item === null || item === void 0 ? void 0 : (_item$product6 = item.product) === null || _item$product6 === void 0 ? void 0 : _item$product6.optionalValues.toString()))]) : _vm._e(), (item === null || item === void 0 ? void 0 : (_item$product7 = item.product) === null || _item$product7 === void 0 ? void 0 : _item$product7.type) == 'addition' ? _c('div', [_vm._v("[" + _vm._s(item === null || item === void 0 ? void 0 : (_item$product8 = item.product) === null || _item$product8 === void 0 ? void 0 : _item$product8.additionalName.toString()) + "] : " + _vm._s(item === null || item === void 0 ? void 0 : (_item$product9 = item.product) === null || _item$product9 === void 0 ? void 0 : _item$product9.additionalValue.toString()))]) : _vm._e()])], 1)];
      }
    }, {
      key: "item.order.buyer",
      fn: function (_ref5) {
        var item = _ref5.item;
        return _c('div', {}, [_c('div', [_vm._v(_vm._s(item.order.buyer.name) + " (" + _vm._s(item.order.buyer.username) + ")")]), _c('div', [_vm._v(_vm._s(item.order.buyer.phone))]), _c('div', [_vm._v(_vm._s(item.order.buyer.email))])]);
      }
    }, {
      key: "item.order.receiver",
      fn: function (_ref6) {
        var item = _ref6.item;
        return _c('div', {}, [_c('div', [_vm._v(_vm._s(item.order.receiver.name))]), _c('div', [_vm._v(_vm._s(item.order.receiver.phone))]), _c('div', [_vm._v(_vm._s(item.order.receiver.email))])]);
      }
    }, {
      key: "item.order.shippingAddress",
      fn: function (_ref7) {
        var item = _ref7.item;
        return _c('div', {}, [_c('div', [_vm._v("[" + _vm._s(item.order.shippingAddress.postcode) + "]")]), _c('div', [_vm._v(_vm._s(item.order.shippingAddress.address1))]), _c('div', [_vm._v(_vm._s(item.order.shippingAddress.address2))])]);
      }
    }, {
      key: "item.shippingInfo",
      fn: function (_ref8) {
        var _vm$couriers$find;
        var item = _ref8.item;
        return _c('div', {}, [_c('div', [_vm._v(_vm._s(item.shippingInfo.method))]), _c('div', [_vm._v(_vm._s(item.shippingInfo.invoiceNumber))]), _c('div', [_vm._v(_vm._s((_vm$couriers$find = _vm.couriers.find(function (courier) {
          return courier.code == item.shippingInfo.courier;
        })) === null || _vm$couriers$find === void 0 ? void 0 : _vm$couriers$find.text))])]);
      }
    }, {
      key: "item.order.cashbill.status",
      fn: function (_ref9) {
        var item = _ref9.item;
        return _c('div', {}, [item.order.cashbill.status ? _c('div', [_c('div', [_vm._v(_vm._s(item.order.cashbill.identityNum))]), _c('div', [_vm._v("신청")])]) : _c('div', [_vm._v("미신청")])]);
      }
    }, {
      key: "item.product.costPrice",
      fn: function (_ref10) {
        var item = _ref10.item;
        return _c('span', {}, [_vm._v(_vm._s(item.product.costPrice.format()) + "원")]);
      }
    }, {
      key: "item.order.totalAmount",
      fn: function (_ref11) {
        var item = _ref11.item;
        return _c('span', {}, [_vm._v(_vm._s(item.order.totalAmount.format()) + "원")]);
      }
    }, {
      key: "item.ebookCommissionAmount",
      fn: function (_ref12) {
        var item = _ref12.item;
        return _c('span', {}, [_vm._v(_vm._s(item.ebookCommissionAmount.format()) + "원")]);
      }
    }, {
      key: "item.order",
      fn: function (_ref13) {
        var item = _ref13.item;
        return _c('span', {}, [_vm._v(_vm._s(_vm.paymentWay(item)))]);
      }
    }, {
      key: "item.createdAt",
      fn: function (_ref14) {
        var item = _ref14.item;
        return _c('span', {}, [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")))]);
      }
    }], null, true)
  }), _c('v-pagination', {
    staticClass: "mt-3",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function ($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function ($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }